import React, { useState } from 'react';
import { Eye, FileText } from 'lucide-react';
import toast from 'react-hot-toast';

/** "View / Download PDF" (opens the styled document) + "Download Word" buttons. */
const DocumentDownloadButtons = ({ onView, onDownloadDocx }) => {
  const [downloading, setDownloading] = useState(false);

  const handleDocx = async () => {
    try {
      setDownloading(true);
      await onDownloadDocx();
    } catch (error) {
      console.error('Download docx error:', error);
      toast.error('Failed to download Word document');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="flex gap-2">
      <button
        onClick={onView}
        className="flex items-center gap-1.5 px-3 py-2 bg-blue-50 text-blue-700 border border-blue-200 rounded-md text-sm hover:bg-blue-100"
      >
        <Eye className="h-4 w-4" />
        View / PDF
      </button>
      <button
        onClick={handleDocx}
        disabled={downloading}
        className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 text-gray-700 border border-gray-200 rounded-md text-sm hover:bg-gray-100 disabled:opacity-50"
      >
        <FileText className="h-4 w-4" />
        {downloading ? 'Downloading...' : 'Word'}
      </button>
    </div>
  );
};

export default DocumentDownloadButtons;
